import { render, staticRenderFns } from "./List.vue?vue&type=template&id=758a7dae"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('758a7dae')) {
      api.createRecord('758a7dae', component.options)
    } else {
      api.reload('758a7dae', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=758a7dae", function () {
      api.rerender('758a7dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/List.vue"
export default component.exports